// Validação compartilhada de quantidades inteiras positivas (> 0).
// Centraliza o padrão que estava duplicado em PedidoForm.jsx (validarItem)
// e Pedidos.js (validarQtdeEntregue).
export const validarQuantidadePositiva = (raw, mensagemErro = 'Quantidade deve ser maior que zero') => {
  const qtde = /^\d+$/.test(String(raw ?? '').trim()) ? parseInt(raw, 10) : null;
  if (qtde === null || qtde <= 0) {
    return { ok: false, erro: mensagemErro };
  }
  return { ok: true, qtde };
};

// Quantidade inteira NÃO-NEGATIVA (>= 0) — 0 é legítimo (entrega parcial por material).
// Diferente de validarQuantidadePositiva, que exige > 0. Vazio vira 0.
export const parseQuantidadeNaoNegativa = (raw, mensagemErro = 'Quantidade entregue inválida') => {
  const s = String(raw ?? '').trim();
  if (s === '') return { ok: true, qtde: 0 };
  if (!/^\d+$/.test(s)) return { ok: false, erro: mensagemErro };
  return { ok: true, qtde: parseInt(s, 10) };
};
